(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["recommended-products"] && !Shopify.designMode) return;
  try {
    const recommendations = document.querySelector('.recommendations');
  const url = recommendations.dataset.url;

  const getRecommendations = async () => {
    const res = await fetch(url);
    const text = await res.text();

    const html = document.createElement('div');
    html.innerHTML = text;

    if (recommendations && recommendations.innerHTML.trim().length) {
      const x = html.querySelector('.recommendations');
      recommendations.parentNode.innerHTML = x.parentNode.innerHTML;
    }
  };

  getRecommendations();
  } catch(e) { console.error(e); }
})();

})();
